import React, { useEffect, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  FileUploadContainer,
  FormField,
  DragDropText,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon,
  InputLabel,
} from "./file-upload.styles";
import { v4 as uuidv4 } from 'uuid';
import {
  AppraisalAttachment,
  InvestmentForAppraisalModel,
} from "../../../all_Interfaces";
import { useAppSelector } from "../../../redux/hooks";
import { UserContext } from "../../../redux/slices/userContextSlice";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { updateAttachments } from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { GlobalFund } from "../../../redux/slices/SelectedGlobalFundSlice";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
import { letterSpacing } from "html2canvas/dist/types/css/property-descriptors/letter-spacing";

const ReactFileUpload = (props: any) => {
  const dispatch = useDispatch();
  const [docType, setDocType] = useState<string>("");
  const [attachmentTag, setAttachmentTag] = useState<string>("");
  const path = window.location.pathname;


  const [existingAttachments, setExistingAttachments] = useState<AppraisalAttachment[]>([]);
  const selectedInvestment: InvestmentForAppraisalModel = useAppSelector(
    (state) => state.SelectedInvestmentForAppraisal.data
  );
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );
  const selectedFund : GlobalFund = useAppSelector(state => state.selectedGlobalFund.data);

  const existingAttachmentList:AppraisalAttachment[] = useAppSelector(state => state.UpdateExistingAttachments.data);
  const newAddedAttachments:AppraisalAttachment[] = useAppSelector(state => state.AddNewAttachments.data);


  useEffect(() => {
    setExistingAttachments(existingAttachmentList);
  },[existingAttachmentList]);



  useEffect(() => {
    setDocType(props.docType);
    setAttachmentTag(props.attachmentTag);
  }, [props.docType, props.attachmentTag]);

  const formatDate = () => {
    const currentDate = new Date();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 to get the correct month (0-indexed)
    const year = currentDate.getFullYear().toString().slice(-2); // Getting the last two digits of the year
  
    return month + year;
  };

  const convertUtcToEst  = (utcDate: Date): string => {
		const options = {
			year: 'numeric', month: 'short', day: 'numeric',
			hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false,
			timeZone: 'America/New_York'
		};

    var date = new Date(utcDate);

    const formattedTime = date.toLocaleTimeString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Use 24-hour format
      timeZone: 'America/New_York'
    });
   // var q = new Intl.DateTimeFormat('en-US',options).format(utcDate);
		return formattedTime;
	}

  const addNewFiles = (newFiles:any) => {
    console.log(selectedInvestment.fund);
    var attachmentList:AppraisalAttachment[] = [];
    for (let file of newFiles){
      let tempSelectedFile = new AppraisalAttachment();
      tempSelectedFile.guid = uuidv4();
      tempSelectedFile.doctype = docType;
      var fileExist = newAddedAttachments.filter(i => i.fileName.includes(file.name) && i.doctype.includes(docType));
      var isFileExistinExistingFileList = existingAttachments.filter(i => i.fileName.includes(file.name) && i.doctype.includes(docType));
      if(fileExist.length == 0 && isFileExistinExistingFileList.length == 0){
        let currentDate = new Date();
        // const regexForFileType = /\/([^/]+)$/;
        const currentUtcDate = new Date(Date.parse(currentDate.toUTCString()));
        tempSelectedFile.fileSize = file.size;
        tempSelectedFile.file = file;
        tempSelectedFile.fileType = file.type;
        tempSelectedFile.lastModifiedBy = userContext.firstName + " " + userContext.lastName;
        tempSelectedFile.lastModifiedTime = currentUtcDate.getTime();
        // tempSelectedFile.lastModifiedDate = currentUtcDate;
        tempSelectedFile.lastModifiedDate = currentDate;

        console.log(currentUtcDate);
        tempSelectedFile['estUploadDate'] = convertUtcToEst(currentUtcDate);
        let tempFileName:string = "";
        const fileDocType = docType === "CASA Valuation Proforma" ? "Excel Valuation Proforma" : docType;
        if (path.includes("global")) {
          tempFileName = selectedFund.fundId + "_" + selectedFund.fundName + "_" + fileDocType + "_" + formatDate() + "_" + file.name;
        }
        if (path.includes("main")) {
          tempFileName = selectedInvestment.investmentId + "_" + selectedInvestment.name + "_" + props.appraisalType + "_" + fileDocType + "_" + formatDate() + "_" + file.name;
        }

        let formattedFileName = tempFileName.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>,\/\\\?-]/g, '');
        tempSelectedFile.fileName = formattedFileName;
        const regexForAvux = /\.avux/;
        const regexForXlsx = /\.xlsx/;
        var isAVUX = regexForAvux.test(file.name);
        var isXlsx = regexForXlsx.test(file.name);
        
        // if(isAVUX || isXlsx){
          const reader = new FileReader();
          reader.onload = (e) => {
            const base64String = e.target?.result;
            console.log("base64 >>>",base64String);
            tempSelectedFile.fileAsBase64 = base64String != null ? base64String as string : ""; // This is the Base64 encoded string
          };

          tempSelectedFile.fileType = isAVUX ? "avux": "xlsx";

          reader.onerror = (e) =>{
            console.log("error in base 64 >>>", e)
          }
      
          reader.readAsDataURL(file);
        // }else{
        //   tempSelectedFile.fileAsBase64 = "";
        // }
        attachmentList.push(tempSelectedFile);
        

      }else{
        //set Tost msg File already exist with file name
      }
    };
        props.setNewAttachments([...attachmentList]);
        // dispatch(addNewAttachments([...newAttachment,tempSelectedFile]));
        dispatch(updateAttachments([...existingAttachments,...attachmentList]));
    
  };

  // useEffect(()=>{
  //   console.log(newAttachment);
  // },[newAttachment])

  
  const handleNewFileUpload = (e: any) => {
    const { files: newFiles } = e.target;
    if(newFiles.length){
      if (docType === "CASA Valuation Proforma") {
        const invalidFiles = Array.from(newFiles).filter((file: any) => !file.name.endsWith(".xlsx"));
        if (invalidFiles.length > 0) {
          alert("Only .xlsx files are allowed for Excel Valuation Proforma.");
          e.target.value = "";
          return;
        }
      }
    addNewFiles(newFiles);
    }
    console.log(newFiles);
  };
  return (
    <>
      <FileUploadContainer className="upload-file-wrap">
        <CloudUploadIcon />
        <DragDropText>Drop files to attach, or browse</DragDropText>
        {docType == "CASA Valuation Proforma" && <DragDropText style={{color:'red',fontSize: '12.5px', letterSpacing:'0'}} >Note: Please ensure the file format is '.xlsx'.</DragDropText>}
        <FormField multiple onChange={handleNewFileUpload} type="file" accept={docType === "CASA Valuation Proforma" ? ".xlsx" : undefined} />
      </FileUploadContainer>
    </>
  );
};

export default ReactFileUpload;
